import {
	getHttpClient,
	MarketplaceApi,
	NonCustodialProviderManagementApi,
	UserApi,
	VtManagementApi,
	WalletApi
} from '@capsicum/common';

export const walletApi = getHttpClient.then(client => new WalletApi(client));
export const marketplaceApi = getHttpClient.then(client => new MarketplaceApi(client));
export const voucherApi = getHttpClient.then(client => new VtManagementApi(client));
export const ncWalletApi = getHttpClient.then(client => new NonCustodialProviderManagementApi(client));

export const userApi = getHttpClient.then(client => new UserApi(client));

export {
	fetchExternalAddressById,
	fetchExternalAddresses,
	postExternalAddress,
	putExternalAddress
} from './externalAdresses';
export { fetchLedgerSummary, fetchLedgerSummaryByLedgerId, fetchLimitLedgerRemaining } from './ledger';
export { fetchCumulativeLimits } from './limits';
export { fetchNativeCurrencies } from './nativeCurrencies';
export {
	fetchUserTransactionHistoryByTransactionId,
	fetchUserTransactionHistorySummaryByType,
	fetchUserTransactionHistorySummaryLastByType
} from './transactionHistory';
export { cancelMarketplaceOrder } from './transactions';
export { fetchWalletTransferOutCost, postWalletTransferOut } from './transferOut';
export { fetchUserAuthMethods, postUserAuthenticationValidate } from './userAuthMethods';
export { useVoucherQuery } from './voucher';
